export const getAntdColumnMaxWidth = (width) => ({
  onHeaderCell: () => ({
    style: { maxWidth: width, minWidth: width },
  }),
  onCell: () => ({
    style: { maxWidth: width, minWidth: width },
  }),
})

export const getAntdColumnMinMaxWidth = (minWidth, maxWidth) => ({
  onHeaderCell: () => ({
    style: { maxWidth: maxWidth, minWidth: minWidth },
  }),
  onCell: () => ({
    style: { maxWidth: maxWidth, minWidth: minWidth },
  }),
})



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/libs/table/utils.js